import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  z-index: 999999;

  background: '#1e1e2f';
  color: #fff;

  @media (max-width: 1300px) {
    min-width: 300px;
  }
`;

export const TextLoding = styled.span`
  color: var(--Takeat-Colors-Neutrals-Black-01, #222);

  /* Label/Label Large/Medium | 500 */
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.1px;
`;

export const ContainerMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  align-self: stretch;
`;
